export function pad(value: number, width: number, char: string = '0'): string {
  const valueAsString: string = String(value);
  return char.repeat(Math.max(0, width - valueAsString.length)) + valueAsString;
}
